import React from 'react'
import { isAdmin } from '@cpsy-rmap-project/web-core/utils'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { useSnackbar } from 'notistack'
import { useUsecaseUser } from '../../../usecases/user'
import { useLoading } from '../../atoms/Loading'
import { useLogin } from '../../organisms/Login'

export const Component: React.FC = () => {
  const [open, setOpen] = React.useState(false)
  const { deleteUser } = useUsecaseUser()
  const { handleIsLoading } = useLoading()
  const snackbar = useSnackbar()
  const { fbUser } = useLogin()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    handleIsLoading(true)
    try {
      await deleteUser()
      handleClose()
      snackbar.enqueueSnackbar('Successfully deleted.', {
        variant: 'success'
      })
    } catch (error: any) {
      console.error(error)
      handleClose()
      if (error.code === 'auth/requires-recent-login') {
        snackbar.enqueueSnackbar('Re-authentication is required. Please logout and login again.', {
          variant: 'error'
        })
      } else {
        snackbar.enqueueSnackbar('Oops! something went wrong.', {
          variant: 'error'
        })
      }
    } finally {
      handleIsLoading(false)
    }
  }

  return (
    <>
      <Box style={{ textAlign: 'center', margin: '10px' }}>
        {isAdmin({ fbUser }) ? (
          <p>Adminアカウントは削除できません</p>
        ) : (
          <Button variant="outlined" color="secondary" size="medium" onClick={handleClickOpen}>
            Delete Account
          </Button>
        )}
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete your account?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Papers you registered will not be deleted. Please Delete them individually if necessary. Once deleted, you
            cannot restore your account. Do you really want to delete your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
          <Button onClick={handleClose} color="default" autoFocus>
            Cancel
          </Button>
          <Button
            onClick={async () => {
              await handleDelete()
            }}
            color="secondary"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Component
